import * as moment from 'moment';

export function getNowSecondsOffset(): number {
  const nowSeconds = +moment().format('s');
  return nowSeconds;
}
